import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(0);
  const categories = Array.from(new Set(faqs.map((f) => f.category)));

  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
        <aside className="lg:col-span-1">
          <div className="sticky top-24 rounded-2xl border border-background-200/70 bg-background-50 p-6">
            <h2 className="text-sm font-bold text-foreground-950">问题分类</h2>
            <ul className="mt-4 space-y-2">
              {categories.map((c) => (
                <li key={c}>
                  <a
                    href={`#faq-${c}`}
                    className="flex items-center justify-between rounded-xl bg-background-100 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  >
                    {c}
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-50 text-xs">
                      {faqs.filter((f) => f.category === c).length}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6 rounded-xl bg-accent-100 p-4">
              <p className="text-sm font-semibold text-accent-800">没找到你的问题？</p>
              <p className="mt-1 text-xs leading-relaxed text-accent-700">
                欢迎通过关于我们页面的联系方式向我们反馈，我们会尽快回复。
              </p>
            </div>
          </div>
        </aside>

        <div className="lg:col-span-2">
          {categories.map((c) => {
            const group = faqs.filter((f) => f.category === c);
            return (
              <div key={c} id={`faq-${c}`} className="scroll-mt-24">
                <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
                  <i className="ri-price-tag-3-line text-primary-500"></i>
                  {c}
                </h2>
                <div className="mt-5 divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 px-5 md:px-8">
                  {group.map((f) => {
                    const key = `${c}-${f.q}`;
                    const idx = faqs.indexOf(f);
                    const isOpen = open === idx;
                    return (
                      <div key={key}>
                        <button
                          type="button"
                          onClick={() => setOpen(isOpen ? null : idx)}
                          className="flex w-full items-center justify-between gap-4 py-5 text-left"
                          aria-expanded={isOpen}
                        >
                          <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                          <span
                            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-foreground-600 transition-transform ${
                              isOpen ? 'rotate-180 bg-primary-100 text-primary-700' : 'bg-background-100'
                            }`}
                          >
                            <i className="ri-arrow-down-s-line"></i>
                          </span>
                        </button>
                        {isOpen && (
                          <p className="pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}